import { Host, h } from '@stencil/core';
export class AibaDonut {
  constructor() {
    this.handleClickDonut = (event) => {
      this.handleClick && this.handleClick(event);
    };
    this.setDonutSize = () => {
      this.progressCircleBackgroundRef && (this.progressCircleBackgroundRef.style.width = `${this.size}px`);
      this.progressCircleBackgroundRef && (this.progressCircleBackgroundRef.style.height = `${this.height}px`);
      this.progressCircleBackgroundRef && (this.progressCircleBackgroundRef.style.borderRadius = `${this.height}px ${this.height}px 0 0`);
      this.progressCircleSubHeading && (this.progressCircleSubHeading.style.width = `${this.size}px`);
      this.progressCircleMaskRef && (this.progressCircleMaskRef.style.height = `${this.height}px`);
      this.progressCircleMaskRef && (this.progressCircleMaskRef.style.borderRadius = `${this.height}px ${this.height}px 0 0`);
    };
    this.componentWillLoad = async () => {
      let resetValue, adjustedPercentage;
      if (this.handlers && this.handlers.handleSemiDonutLoad) {
        const dataFromAnalysis = await this.handlers.handleSemiDonutLoad();
        this.value = (dataFromAnalysis === null || dataFromAnalysis === void 0 ? void 0 : dataFromAnalysis.value) ? dataFromAnalysis.value : this.value;
        this.height = (dataFromAnalysis === null || dataFromAnalysis === void 0 ? void 0 : dataFromAnalysis.height) ? dataFromAnalysis.height : this.height;
        this.variant = (dataFromAnalysis === null || dataFromAnalysis === void 0 ? void 0 : dataFromAnalysis.variant) ? dataFromAnalysis.variant : this.size;
        this.variant = (dataFromAnalysis === null || dataFromAnalysis === void 0 ? void 0 : dataFromAnalysis.variant) ? dataFromAnalysis.variant : this.variant;
      }
      if (this.isScaleEnabled) {
        resetValue = Math.round((Number(this.value) / 100) * this.scaleRange);
        adjustedPercentage = this.variant === 'neutral' ? 100 : (resetValue * 100) / this.scaleRange;
      }
      else {
        resetValue = Number(this.value) * 100;
        adjustedPercentage = this.variant === 'neutral' ? 100 : resetValue / 100;
      }
      setTimeout(() => {
        this.rotateThis = `rotate(${adjustedPercentage * 1.8}deg)`;
        this.progressCircleWheelRef && (this.progressCircleWheelRef.style.transform = this.rotateThis);
      }, 500);
    };
    this.componentDidLoad = async () => {
      this.setDonutSize();
    };
    this.value = 85;
    this.height = 134;
    this.size = 280;
    this.data = undefined;
    this.variant = 'low';
    this.styles = undefined;
    this.classes = undefined;
    this.handleClick = undefined;
    this.isScaleEnabled = false;
    this.scaleRange = 10;
    this.handlers = undefined;
    this.donutHeading = '';
    this.rotateThis = 'rotate(0deg)';
    this.content = undefined;
  }
  render() {
    var _a;
    if (typeof this.data === 'string') {
      if (this.data) {
        this.data = JSON.parse(this.data);
      }
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: "donut-wrapper-container", tabIndex: this.handleClick ? 0 : null, role: this.handleClick ? 'button' : '', onClick: (event) => this.handleClickDonut && this.handleClickDonut(event) }, this.data &&
      ((_a = this.data.elements) === null || _a === void 0 ? void 0 : _a.map((element) => {
        var _a;
        if (element && element['name'] === 'aiba-circle')
          return (h("div", { class: `progress-semi-circle-wrapper` }, h("div", { class: `progress-semi-circle-background ${this.variant ? this.variant : ''}`, ref: el => (this.progressCircleBackgroundRef = el) }, h("div", { class: `progress-semi-circle ${this.variant ? this.variant : ''}`, ref: el => (this.progressCircleRef = el) }, h("div", { class: `progress-semi-circle-wheel ${this.variant ? this.variant : ''}`, ref: el => (this.progressCircleWheelRef = el) }), h("div", { class: `progress-semi-circle-mask ${this.variant ? this.variant : ''}`, ref: el => (this.progressCircleMaskRef = el) }, h("aiba-label", Object.assign({}, element['data'], { text: this.value + '%' })))))));
        if (element && element['name'] === 'aiba-label' && element['_id'] === 'subheading')
          return h("aiba-label", Object.assign({}, element['data'], { text: ((_a = this.content) === null || _a === void 0 ? void 0 : _a.name) ? this.content.name : element['data']['text'] }));
        if (element && element['name'] === 'aiba-label') {
          if (this.donutHeading.length > 0) {
            element['data'].text = this.donutHeading;
          }
          return (h("div", { class: `donut-heading ${this.variant ? this.variant : ''}`, ref: el => (this.progressCircleSubHeading = el) }, h("aiba-label", Object.assign({}, element['data']))));
        }
      })), h("slot", null))));
  }
  static get is() { return "aiba-semi-donut"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-semi-donut.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-semi-donut.css"]
    };
  }
  static get properties() {
    return {
      "value": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "value",
        "reflect": false,
        "defaultValue": "85"
      },
      "height": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "height",
        "reflect": false,
        "defaultValue": "134"
      },
      "size": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "size",
        "reflect": false,
        "defaultValue": "280"
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'low' | 'medium' | 'average' | 'high' | 'neutral'",
          "resolved": "\"average\" | \"high\" | \"low\" | \"medium\" | \"neutral\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": false,
        "defaultValue": "'low'"
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "handleClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-click",
        "reflect": false
      },
      "isScaleEnabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-scale-enabled",
        "reflect": false,
        "defaultValue": "false"
      },
      "scaleRange": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "scale-range",
        "reflect": false,
        "defaultValue": "10"
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "donutHeading": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "donut-heading",
        "reflect": false,
        "defaultValue": "''"
      },
      "content": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "content",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "rotateThis": {}
    };
  }
}
//# sourceMappingURL=aiba-semi-donut.js.map
